module.exports = __webpack_public_path__ + "media/Icons/GuinoOk-a32e97cf.svg";